import { TemplateRef } from '@angular/core';
import { IntelligenceModels } from '@models/intelligence.model';
import {
  CellTemplateContext,
  copyLinkAction,
  DatasetTableConfig,
  TableConfigBuilder,
  textColumn,
} from '@ui/lib/ui-kit/ui-dataset-table';

type UserOrganization = IntelligenceModels.Organizations.UserOrganization;

export type UserOrganizationResultCellContext = CellTemplateContext<UserOrganization>;

export interface CreateUserOrganizationsResultTableConfigDependencies {
  /** Name cell: organization name plus the Active badge for the caller's active row. */
  nameCellTemplate: TemplateRef<UserOrganizationResultCellContext>;
}

export function createUserOrganizationsResultTableConfig(
  dependencies: CreateUserOrganizationsResultTableConfigDependencies,
): DatasetTableConfig<UserOrganization> {
  return new TableConfigBuilder<UserOrganization>()
    .columns([
      {
        ...textColumn<UserOrganization>('name', 'USER_ORGANIZATIONS_RESULT.TABLE.NAME', {
          width: 'minmax(180px, 2fr)',
          sortable: true,
          mobileVisible: true,
          cardBoldValue: true,
        }),
        cellTemplate: dependencies.nameCellTemplate,
      },
      textColumn<UserOrganization>('id', 'USER_ORGANIZATIONS_RESULT.TABLE.ID', {
        width: 'minmax(200px, 1.5fr)',
        sortable: true,
        mobileVisible: true,
      }),
    ])
    .trackBy('id')
    .rowHeight(52)
    .actions([
      copyLinkAction<UserOrganization>({
        label: 'USER_ORGANIZATIONS_RESULT.COPY_ID',
        tooltip: 'USER_ORGANIZATIONS_RESULT.COPY_ID',
        copyFrom: 'id',
      }),
    ])
    .build();
}
